// Libs
import React, { useEffect, useState } from 'react';
import { graphql } from 'gatsby';

// Pages
import Layout from '../../components/Layout';
import SEO from '../../components/seo';
import BlogList from '../../components/BlogList';

export const IndexQuery = graphql`
  query {
    blog {
      posts (locales: [pt_BR], orderBy: date_DESC) {
        id
        slug
        title
        coverImage (locales: [en]) {
          url
        }
        intro
        author
        authorPicture (locales: [en]) {
          url
        }
        date
        content {
          html
        }
      }
    }
  }
`;

const Blog = ({ data }) => {
  const [widthSize, setWidthSize] = useState('');

  const hasWindow = typeof window !== 'undefined';
  const isMobile = widthSize <= 480;
  const language = 'pt-BR';

  const handleWidthSize = () => {
    const widthViewPort = document.documentElement.clientWidth;

    setWidthSize(widthViewPort);
  }

  useEffect(() => {
    if (hasWindow) {
      handleWidthSize();
      window.addEventListener('resize', handleWidthSize);

      return () => {
        window.removeEventListener('resize', handleWidthSize);
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Layout
      language={language}
      isMobile={isMobile}
      type='blog'
    >
      <SEO
        lang='en-US'
        title='Blog'
        ogTitle='Manage and Boost Team’s Work, Projects and Tasks | Strytegy'
        description='➤ Manage and Boost Team’s Work, Projects and Tasks 100% Online ✅ ➤ Easily organize workflows and ✚ Start using Strategy as your work management tool!'
        alternativeLang='pt-br'
        alternativeLink='https://www.strytegy.com/faq/pt-br/'
        canonicalLink='https://www.strytegy.com/faq/en-us/'
      />
      <BlogList
        language={language}
        isMobile={isMobile}
        postList={data.blog.posts}
      />
    </Layout>
  )
}

export default Blog;
